import React from "react";
import { Typography, TextField } from "@mui/material";

const StandardCakeSEO = ({ formData, setFormData }) => {
  const { seo } = formData;

  const handleSEOChange = (updated) => {
    setFormData((prev) => ({
      ...prev,
      seo: {
        ...prev.seo,
        ...updated,
      },
    }));
  };

  return (
    <>
      <Typography sx={{ mt: 2, mb: 1 }}>SEO Information</Typography>

      <TextField
        margin="dense"
        name="seo.metaTitle"
        label="Meta Title"
        fullWidth
        value={seo.metaTitle}
        onChange={(e) => handleSEOChange({ metaTitle: e.target.value })}
      />

      <TextField
        margin="dense"
        name="seo.metaDescription"
        label="Meta Description"
        fullWidth
        value={seo.metaDescription}
        onChange={(e) => handleSEOChange({ metaDescription: e.target.value })}
      />

      <TextField
        margin="dense"
        name="seo.metaKeywords"
        label="Meta Keywords (comma-separated)"
        fullWidth
        value={seo.metaKeywords}
        onChange={(e) => handleSEOChange({ metaKeywords: e.target.value })}
        helperText="Enter keywords separated by commas"
      />
    </>
  );
};

export default StandardCakeSEO;
